export default {

  handleLogin() {

    let oForm = $('.login-form');

    let aRules = {
      username: {
        required: true
      },
      password: {
        required: true
      },
      remember: {
        required: false
      }
    };

    let aMessages = {
      username: {
        required: 'El Usuario es obligatorio.'
      },
      password: {
        required: 'La Contraseña es obligatoria.'
      }
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);

    if (oForm.length > 0) {
      oForm.find('input').keypress(e => {
        if (e.which == 13) {
          if (oForm.validate().form()) {
            oForm.submit();
          }
          return false;
        }
      });
      oForm.find('input:enabled:visible:first').focus();
    }
  },

  handleForgetPassword() {
    let oForm = $('.forget-form');

    let aRules = {
      email: {
        required: true,
        email: true
      }
    };

    let aMessages = {
      email: {
        required: 'El E-mail es obligatorio.',
        email: 'El E-mail es inválido.'
      }
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);

    if (oForm.length > 0) {
      oForm.find('input').keypress(e => {
        if (e.which == 13) {
          if (oForm.validate().form()) {
            oForm.submit();
          }
          return false;
        }
      });

      $('#forget-password').click(() => {
        $('.login-form').hide();
        $('.forget-form').show()
          .find('input:enabled:visible:first').focus();
      });

      $('#back-btn').click(() => {
        $('.login-form').show()
          .find('input:enabled:visible:first').focus();
        $('.forget-form').hide();
      });
    }
  },

  init() {
    this.handleLogin();
    this.handleForgetPassword();
  }
};
